import { IAddToolCheckItemTemplate } from '../../models/forms/IToolCheckItemTemplate';

export const AddToolCheckItemTemplateInitialState: IAddToolCheckItemTemplate = {
  Id: -1,
  CheckItemName: '',
  Remarks: '',
  Headers: [],
};

export default AddToolCheckItemTemplateInitialState;
